import { SvgProps } from "./types";

export default function GlassIcons(props: SvgProps) {
    return (
        <svg {...props} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.0825 0.5H1.91746C0.666737 0.5 0.031324 1.99507 0.903173 2.88652L3.1959 5.5H12.8041L15.0968 2.88652C15.9687 1.99507 15.3333 0.5 14.0825 0.5Z" fill="currentColor" />
            <path d="M11.7075 6.75H4.29249L7.3748 10.2635V14.8749H4.46322C4.11804 14.8749 3.83822 15.1547 3.83822 15.4999C3.83822 15.8451 4.11804 16.1249 4.46322 16.1249H11.5364C11.8816 16.1249 12.1614 15.8451 12.1614 15.4999C12.1614 15.1547 11.8816 14.8749 11.5364 14.8749H8.6248V10.264L11.7075 6.75Z" fill="currentColor" />
        </svg>

    );
}